import React from "react";
import { useMessageSource } from "react-message-source";
import SwissGold from "../../../../resources/images/scd-product-swiss-gold.png";
import SwissPlatinum from "../../../../resources/images/scd-product-swiss-platinum.png";
import SwissSilver from "../../../../resources/images/scd-product-swiss-silver.png";
import CSSilver from "../../../../resources/images/scd-product-cs-silver.png";
import CSGold from "../../../../resources/images/scd-product-cs-gold.png";
import CS_MASTERCARD_BUSINESS_EURO from "../../../../resources/images/scd-product-cs-mastercard-business-euro.png";
import CS_MASTERCARD_BUSINESS_STANDARD_CHF from "../../../../resources/images/scd-product-cs-mastercard-business-standard-chf.png";
import CS_MASTERCARD_BUSINESS_GOLD_CHF from "../../../../resources/images/scd-product-cs-mastercard-business-gold-chf.png";
import SC_MASTERCARD_BUSINESS_GOLD_CHF_IMAGE from "../../../../resources/images/scd-product-sc-mastercard-business-gold-chf.png";
import SC_MASTERCARD_BUSINESS_SILVER_CHF_IMAGE from "../../../../resources/images/scd-product-sc-mastercard-business-silver-chf.png";
import SC_MASTERCARD_BUSINESS_GOLD_EUR_IMAGE from "../../../../resources/images/scd-product-sc-mastercard-business-gold-eur.png";
import SC_MASTERCARD_BUSINESS_CORPORATE_USD_IMAGE from "../../../../resources/images/scd-product-sc-mastercard-business-corporate-usd.png";
import CUSTOMIZED_IMAGE from "../../../../resources/images/scd-product-customized-card.png";
import Image from "../../../../ui/widgets/image";
import { ProductRefType } from "../../../../context/product-context/types";

interface ProductImageProps {
  product: ProductRefType;
  isCustomized?: boolean;
}

function mapProductToImage(
  product: ProductRefType,
  isCustomized: boolean,
): string {
  if (isCustomized) {
    return CUSTOMIZED_IMAGE;
  }

  if (product === ProductRefType.SWISS_GOLD) {
    return SwissGold;
  }

  if (product === ProductRefType.SWISS_SILVER) {
    return SwissSilver;
  }

  if (product === ProductRefType.SWISS_PLATINUM) {
    return SwissPlatinum;
  }

  if (product === ProductRefType.CS_DUO_SILVER) {
    return CSSilver;
  }

  if (product === ProductRefType.CS_DUO_GOLD) {
    return CSGold;
  }

  if (product === ProductRefType.CS_MASTERCARD_BUSINESS_EURO) {
    return CS_MASTERCARD_BUSINESS_EURO;
  }

  if (product === ProductRefType.CS_MASTERCARD_BUSINESS_STANDARD_CHF) {
    return CS_MASTERCARD_BUSINESS_STANDARD_CHF;
  }

  if (product === ProductRefType.CS_MASTERCARD_BUSINESS_GOLD_CHF) {
    return CS_MASTERCARD_BUSINESS_GOLD_CHF;
  }

  if (product === ProductRefType.SC_MASTERCARD_BUSINESS_GOLD_CHF) {
    return SC_MASTERCARD_BUSINESS_GOLD_CHF_IMAGE;
  }

  if (product === ProductRefType.SC_MASTERCARD_BUSINESS_SILVER_CHF) {
    return SC_MASTERCARD_BUSINESS_SILVER_CHF_IMAGE;
  }

  if (product === ProductRefType.SC_MASTERCARD_BUSINESS_GOLD_EUR) {
    return SC_MASTERCARD_BUSINESS_GOLD_EUR_IMAGE;
  }

  if (product === ProductRefType.SC_MASTERCARD_BUSINESS_CORPORATE_USD) {
    return SC_MASTERCARD_BUSINESS_CORPORATE_USD_IMAGE;
  }
}

function mapProductToAltMessageKey(product: ProductRefType): string {
  return `CardImage.${product}.alt`;
}

export default function ProductImage({
  product,
  isCustomized = false,
}: ProductImageProps): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return product ? (
    <Image
      src={mapProductToImage(product, isCustomized)}
      alt={getMessage(mapProductToAltMessageKey(product))}
    />
  ) : null;
}
